<div class="container">
    <h3>Politique de Confidentialité</h3>
    <p>
        Votre vie privée est importante pour nous. Nous collectons uniquement les données suivantes lorsque vous vous inscrivez sur notre site :
    </p>
    <ul>
        <li><strong>Adresse e-mail :</strong> Pour créer un compte et vous connecter.</li>
        <li><strong>Nom d'utilisateur :</strong> Pour identifier votre compte au sein de la communauté.</li>
    </ul>
    <p>
        Nous ne partageons pas vos données personnelles avec des tiers sans votre consentement, sauf si la loi l'exige.
    </p>
    <p>
        Vous avez le droit de demander l'accès à vos données, de les rectifier ou de les supprimer à tout moment. Pour exercer ces droits, veuillez nous contacter à l'adresse suivante : <a href="mailto:marine.deruelle@laposte.net">marine.deruelle&#64;laposte.net</a>.
    </p>
</div>
